import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

const unitsRootObj = {
  '/app/units': 0,
  '/app/properties': 1
}

class UnitsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const selectedTabIndexSession = unitsRootObj[this.component.props.location.pathname] || 0;

    //const selectedTabIndex = this.component.props.app.unitsPageTabIndex;

    this.component.props.dispatch({
      type: Constants.PAGE_UNITS_SWITCH_TAB,
      payload: {
        index: selectedTabIndexSession
      }
    });

    this.component.setState({
      activeTab: selectedTabIndexSession,
      value: selectedTabIndexSession,
    });

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdPerson = this.component.props.app.savedDataBeforeRedirecting.createdPerson;
      const createdCompany = this.component.props.app.savedDataBeforeRedirecting.createdCompany;
      const createdExecutor = this.component.props.app.savedDataBeforeRedirecting.createdExecutor;

      if (typeof createdPerson !== "undefined") {
        this.component.selectedPerson = createdPerson;
      }

      if (typeof createdCompany !== "undefined") {
        this.component.selectedCompany = createdCompany;
      }

      const state = {
        ...this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved,
        selectedPerson: !!createdPerson && !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved && !this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved.isCreateTaskPopupOpen ? createdPerson : !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved.selectedPerson,
        selectedCompany: !!createdCompany ? createdCompany : !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved.selectedCompany,
        executorId: !!createdExecutor && !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved && !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved.isCreateTaskPopupOpen ? createdExecutor.id : !!this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.unitsDataToBeSaved.selectedPerson,
      }

      this.component.setState({
        ...state
      }, () => {
        this.component.setState({hasModifiedData: true}, () => {
          this.component.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
        });
      });
    }
  }
}

export default new UnitsWillMount();
